import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../../stores'

export type FederatedSpecSheetState = {
    available: boolean
    specSheetItemId: string | null
}

const initialState: FederatedSpecSheetState = {
    available: false,
    specSheetItemId: null,
}

const federatedSpecSheetSlice = createSlice({
    name: 'federatedSpecSheet',
    initialState,
    reducers: {
        setFederatedSpecSheetAvailable(state, { payload }: PayloadAction<string>) {
            state.available = true
            state.specSheetItemId = payload
        },
        resetFederatedSpecSheet(state) {
            state.available = false
            state.specSheetItemId = null
        },
    },
})

export const selectFederatedSpecSheetAvailable = (state: RootState) => state.IMUP.federatedSpecSheet.available

export const selectFederatedSpecSheetItemId = (state: RootState) => state.IMUP.federatedSpecSheet.specSheetItemId

export const { setFederatedSpecSheetAvailable, resetFederatedSpecSheet } = federatedSpecSheetSlice.actions

export default federatedSpecSheetSlice
